export default __webpack_public_path__ + "static/media/girl-fog-castle.4d34f4bf.jpg";